<div class="asset-group"
        [ngClass]="{'asset-group-valid': isValid, 'asset-group-invalid': !isValid}">
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div fxFlex="50" class="group-name">{{group.accountGroupName}}</div>
        <div fxFlex="40" class="dep-rule-name">{{group.depRuleName}} ({{group.depRuleAbbreviated}})</div>
        <div>
            <button mat-icon-button
                    class="edit-button"
                    (click)="editGroup()"
                    title="Edit the details and mappings for the '{{group.accountGroupName}}'' asset group">
                <app-icon-core icon="edit"></app-icon-core>
            </button>
        </div>
    </div>
    <div fxLayout="row"  style="margin-bottom: 10px;" *ngIf="depSection && dispSection">
       <div fxFlex="50*">
            <app-group-edit-section [section]="depSection" [selectedSection]="selectedSection"
                [dialogMode]="false"
                [subSection]="true">
            </app-group-edit-section>
        </div>
        <div fxFlex="50*">
            <app-group-edit-section [section]="dispSection" [selectedSection]="selectedSection"
                [dialogMode]="false"
                [subSection]="true">
            </app-group-edit-section>
        </div>
        <div fxFlex="50*" *ngIf="_company.useYearEndJournals">
            <app-group-edit-section 
                [section]="yeSection" 
                [selectedSection]="selectedSection"
                [dialogMode]="false"
                [subSection]="true">
            </app-group-edit-section>
        </div>
    </div>
</div>
